import React, { useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { Autoplay } from 'swiper/modules';

const Home = () => {
  const swiperRef = useRef(null);
  const [videoUrl, setVideoUrl] = useState(null);

  const slides = [
    {
      title: 'FOOD SECURITY',
      subtitle: 'Investing in Agriculture',
      imgSrc: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1748783328/image_1_ghzshs.png',
      video: 'https://res.cloudinary.com/dzngpgki4/video/upload/v1744505363/WhatsApp_Video_2025-04-13_at_5.16.54_AM_tguh1v.mp4',
    },
    {
      title: 'SMART FARMING',
      subtitle: 'Let’s Go Future!',
      imgSrc: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1745008803/image_35_d1uume.png',
      video: 'https://res.cloudinary.com/dzngpgki4/video/upload/v1744505363/WhatsApp_Video_2025-04-13_at_5.16.54_AM_tguh1v.mp4',
    },
    {
      title: 'SMART FARMING',
      subtitle: 'Let’s Go Future!',
      imgSrc: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1745008802/image_36_eupz7n.png',
      video: 'https://res.cloudinary.com/dzngpgki4/video/upload/v1744505363/WhatsApp_Video_2025-04-13_at_5.16.54_AM_tguh1v.mp4',
    },
    {
      title: 'AGRITECH',
      subtitle: 'AgriTech, the future of Agriculture',
      imgSrc: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1744546933/image_jkt1db.png',
      video: 'https://res.cloudinary.com/dzngpgki4/video/upload/v1744505363/WhatsApp_Video_2025-04-13_at_5.16.54_AM_tguh1v.mp4',
    },
    {
      title: 'AGRITECH',
      subtitle: 'AgriTech, the future of Agriculture',
      imgSrc: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1744546932/image-1_tsajab.png',
      video: 'https://res.cloudinary.com/dzngpgki4/video/upload/v1744763710/Agriculture_Minister_sets_tone_for_his_tenure_-_nbc_1_h9rvxi.mp4',
    },
    {
      title: 'AGRITECH',
      subtitle: 'AgriTech, the future of Agriculture',
      imgSrc: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1744546933/image-2_nw1zce.png',
      video: 'https://res.cloudinary.com/dzngpgki4/video/upload/v1744763710/Agriculture_Minister_sets_tone_for_his_tenure_-_nbc_1_h9rvxi.mp4',
    },
  ];

  return (
    <div className="px-4 pt-2 md:px-24 relative">
      <div className="flex justify-between items-center md:px-5 md:-mt-3 md:mb-5">
        <h1 className="text-[16px] sm:text-[27px] md:text-[33px] lg:text-[36px] text-[#FDBD26] font-bold">AGRITECH</h1>
      </div>

      <Swiper
        modules={[Autoplay]}
        ref={swiperRef}
        spaceBetween={50}
        slidesPerView={1}
        loop={true}
      >
        {slides.map((slide, i) => (
          <SwiperSlide key={i}>
            <div className="md:pl-5">
              <div className="relative rounded-tr-xl rounded-tl-xl overflow-hidden h-[180px] md:h-[680px]">
                <img
                  src={slide.imgSrc}
                  alt=""
                  className="w-full h-full object-cover rounded-tr-xl rounded-tl-xl cursor-pointer"
                  onClick={() => window.location.href = "/argitech1"}
                />

                {/* Read More Button */}
                <a
                  href="/argitechmain"
                  onClick={(e) => e.stopPropagation()}
                  className="absolute top-0 left-0 bg-[#152C24] md:rounded-br-[30px] rounded-br-[10px] h-[30px] w-[100px] md:w-[258px] md:h-[70px] z-30"
                >
                <div className='flex md:gap-2 justify-center md:mt-2'>
                <div className="bg-[#2E453D] md:ml-0 ml-2 text-white font-normal md:px-6 px-2 rounded-sm md:rounded-[30px] w-[70px] h-[15px] md:w-[200px] md:text-[20px] text-[8px] md:h-[45px] mt-2 md:-mt-[1px] flex justify-between items-center">
                    See More
                  
                  </div>
                <div className='border-[1px] w-[20px] h-[20px] md:w-[40px] md:h-[40px] flex justify-center md:mt-0 mt-1 mr-2 rounded-full'> 
                <img
                      src="https://res.cloudinary.com/dzngpgki4/image/upload/v1748783006/Expand_right_gzn0vr.png"
                      alt="Arrow"
                      className="md:w-9 md:h-9 w-3 h-3 md:flex hidden"
                    />
                    <img
                      src="https://res.cloudinary.com/dzngpgki4/image/upload/v1748783006/Expand_right_gzn0vr.png"
                      alt="Arrow"
                      className="w-3 h-3 mt-1 md:hidden flex"
                    /> 
                </div>
                </div>
                </a>

                {/* Play Icon */}
                {slide.video && (
                  <div
                    className="absolute inset-0 flex justify-center items-center z-10"
                    onClick={(e) => {
                      e.stopPropagation();
                      setVideoUrl(slide.video);
                    }}
                  >
                    <img
                      src="https://res.cloudinary.com/dzngpgki4/image/upload/v1743776596/image_1502_utmsek.png"
                      alt="Play Icon"
                      className="w-[50px] h-[50px] md:w-[130px] md:h-[130px] object-contain cursor-pointer"
                    />
                  </div>
                )}

                {/* Text Overlays */}
                <div>
                  <h1
                    className={`absolute md:bottom-28 bottom-7 md:left-7 left-3 md:text-[20px] xl:text-[25px] text-[13px] mt-2 font-medium leading-tight ${
                      i === 0 ? 'text-white' : 'text-white'
                    }`}
                  >
                    {slide.title}
                  </h1>
                  <h1
                    className={`absolute md:bottom-14 md:left-7 bottom-3 left-3 md:text-[32px] xl:text-[40px] text-[13px] mt-2 font-bold leading-tight ${
                      i === 0 ? 'text-white' : 'text-white'
                    }`}
                  >
                    {slide.subtitle}
                  </h1>
                </div>

                {/* Arrows */}
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1743894055/Arrow_drop_left_ywufj5.png"
                  alt="Left Arrow"
                  className="md:block absolute left-4 top-1/2 transform -translate-y-1/2 w-10 h-10 md:w-20 md:h-20 z-10 cursor-pointer"
                  onClick={(e) => {
                    e.stopPropagation();
                    swiperRef.current.swiper.slidePrev();
                  }}
                />
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1743894091/Arrow_drop_left_1_othpaw.png"
                  alt="Right Arrow"
                  className="md:block absolute md:right-4 right-4 top-1/2 transform -translate-y-1/2 w-10 h-10 md:w-20 md:h-20 z-10 cursor-pointer"
                  onClick={(e) => {
                    e.stopPropagation();
                    swiperRef.current.swiper.slideNext();
                  }}
                />
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Video Popup */}
      {videoUrl && (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-80 flex items-center justify-center">
          <video
            src={videoUrl}
            controls
            autoPlay
            className="w-[90%] h-auto max-h-[90%] rounded-lg"
          />
          <button
            onClick={() => setVideoUrl(null)}
            className="absolute top-4 right-4 text-white text-3xl font-bold"
          >
            &times;
          </button>
        </div>
      )}
    </div>
  );
};

export default Home;
